export default __webpack_public_path__ + "static/media/market.81d1f7f4.jpg";